import styled from "styled-components";

const Content = styled.div`
  @media screen and (min-width: 961px) {
    width: 1000px;
    margin: 0 auto; 
  }
`;
export default Content;
